module.exports = __webpack_public_path__ + "img/izbrannoe-01.9316f69.svg";